<template>
    <mounting-portal mount-to="#portalvue-latest-galleries-component">
        <div class="bg-blackish"
            :class="classes">

            <div v-if="true === showTitle"
                class="container mx-auto mb-5">
                <div class="flex justify-end">
                    <h2 class="text-40px text-waheed text-cloudy-blue">{{ title }}</h2>

                    <img :src="CDN_GET('assets/mhr/icons/icon-photo-gallery.svg')" 
                        alt="photo gallery icon" 
                        class="ml-3">
                </div>
            </div>

            <div class="container mx-auto overflow-hidden">

                <div v-if="galleries.length > 0"
                    class="flex flex-row-reverse flex-wrap gallery-list-dashed -m-4 overflow-hidden">
                    <div v-for="(gallery, gindex) in galleries"
                        :key="gindex"
                        class="flex flex-row-reverse w-full p-4 border-t border-l border-dashed border-black-two sm:flex-col sm:w-1/2 lg:w-1/4">
                        <featured-media-component
                            :media="gallery.featured_media"
                            :link="gallery.link"
                            :short-headline="gallery.title"
                            class="flex-shrink-0 w-116px h-116px sm:w-full sm:h-174px sm:mb-5" />

                        <div class="flex flex-col justify-between pt-3 pr-4 sm:pt-0 sm:pr-0 sm:h-143px">
                            <a :href="gallery.link">
                                <p class="text-xl text-waheed text-pinkish-grey leading-10 hover:underline">{{ gallery.title }}</p>
                            </a>
                            <div class="flex justify-end mb-4 text-13px text-warm-grey-two">
                                <div class="flex ml-3">
                                    <img :src="CDN_GET('assets/mhr/icons/icon-galleries-listing-photo-count.svg')" />
                                    <span class="ml-1">{{ gallery.photo_count }}</span>
                                </div> 
                                <div class="flex ml-3">
                                    <img :src="CDN_GET('assets/mhr/icons/icon-galleries-listing-time.svg')" />
                                    <span class="ml-1 w-full">{{ gallery.human_time }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="true === isLoading"
                    class="sm:mx-4 xl:-mx-4 overflow-hidden mt-6">
                    <gallery-loading-component />
                </div>

                <div v-if="hasMoreToLoad" 
                    class="w-full flex items-center justify-center mt-10">
                    <img
                        class="cursor-pointer"
                        v-on:click="loadGalleries()"
                        :src="CDN_GET('assets/mhr/icons/icon-galleries-listing-more.svg')"
                        alt="icon load more" />
                </div>
            </div>
        </div>
    </mounting-portal>
</template>

<script>
import GalleryLoadingComponent from '../Loading/GalleryLoadingComponent.vue'
import FeaturedMediaComponent from '../Layout/FeaturedMedia/FeaturedMediaComponent.vue'

export default {
    props: {
        limit: {
            type: Number,
            default: 4
        },
        title: {
            type: String
        },
        showTitle: {
            type: Boolean,
            default: false
        },
        ignore: {
            type: String,
            default: null
        },
        classes: {
            type: String,
            default: ''
        }
    },
    components: {
        FeaturedMediaComponent,
        GalleryLoadingComponent
    },
    data() {
        return {
            galleries: [],
            cursor: null,
            isLoading: true
        }
    },
    computed: {
        hasMoreToLoad() {
            return false === this.isLoading && 
                null !== this.cursor
        }
    },
    methods: {
        loadGalleries(type) {
            this.isLoading = true
            
            let uri = 'home/latest-galleries' +
                '?cursor=' + this.cursor 

            if (null !== this.ignore) {
                uri += '&ignore=' + this.ignore
            }

            axios.get(uri)
                .then(resp => {
                    const response = resp.data

                    if (response.data.length > 0) {
                        this.galleries.push(...response.data)
                        this.cursor = response.cursor
                    }
                    
                })
                .catch(e => {
                    console.error('LatestGalleriesComponent.vue')
                    console.error(e)
                })
                .then(resp => {
                    this.isLoading = false
                });
        }
    },
    mounted() {
        this.loadGalleries('latest')

        console.log(this.classes)
    }
}
</script>